<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 240px;
}

.bar1 {
  height: 250px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="bar-wrap">
    <div class="bar1">
      <div class="main"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {}
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.bar1 .main'));
    this.myChart.setOption({
      xAxis: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        data: ['百色芒果', '圣女果', '牛心李', '八渡笋', '田东香芒', '砂糖橘', '西林火姜'],
        axisLine: {
          lineStyle: {
            color: '#0177d4'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          interval: 0,
          color: '#77CAD8',
          fontSize: 12
        }
      },
      yAxis: {
        nameTextStyle: {
          color: '#77CAD8',
          fontSize: 12
        },
        axisLine: {
          lineStyle: {
            color: '#0177d4'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#77CAD8',
          fontSize: 12
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: '#0177d4'
          }
        }
      },
      series: [{
        type: 'bar',
        barWidth: 18,
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#FCC94A'
            }, {
              offset: 0.8,
              color: '#FF7200'
            }], false)
          }
        },
        data: [4000, 2000, 9000, 5500, 1000, 7000, 8000]
      }]
    })
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?09e5b042